import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ClientList from "../pages/client/List";
import ClientLayout from "../layout/index";
import ActionList from "../pages/Actionlist/List";
import SystemManagerLayout from "../pages/systemManager/SystemManagerLayout";
import { useEffect, useState } from "react";
import ProfileSettings from "../pages/ProfileSettings";
import { checkUserPermission } from "../utils";
import { UserPermissionsList } from "../config";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import Commission from "../pages/systemManager/commission";
import Subscription from "../pages/systemManager/Subscription";
import MasterSttingsPage from "../pages/systemManager/masterSettings/MasterSttingsPage";
import Integrations from "../pages/systemManager/Integrations";
import ContractEnquiry from "../pages/systemManager/ContractEnquiry";
import Templates from "../pages/systemManager/templateEngine/LetterTemplates";
import CompanyDetails from "../pages/systemManager/CompanyDetails/CompanyDetails";
import ProfileRouting from "../pages/ProfileSettings/profileRouting";
import ClientDetailPage from "../pages/client/ClientDetailPage";
import SectionHandler from "../pages/client/SectionHandler";
import PartnerSectionHandler from "../pages/client/PartnerSectionHandler";
import ClientSubMenuItem from "../pages/client/ClientSubMenuItem";
import ClientAddForm from "../pages/client/ClientAddForm";
import CommissionLayout from "../pages/Commission/CommissionLayout/Layout";
import EmailTemplates from "../pages/systemManager/templateEngine/EmailTemplates";
// import ListDetils from "../pages/Commission/OtherFeesCharges/ListDetils";
import UtilitiesLayout from "../pages/utilities/UtilitiesLayout";
import TemplateDropdown from "../pages/utilities/EmailNotification/TemplateDropdown";
import ReceiptList from "../pages/Commission/CommissionReceipts/ReceiptList";
// import FeeschargesList from "../pages/Commission/OtherFeesCharges/FeeschargesList";
import LetterGeneration from "../pages/utilities/EmailNotification/LetterGeneration";
import PartnerSubMenuItem from "../pages/client/PartnerSubMenuItem";
import AssetHomePage from "../pages/client/case/Asset/AssetHomePage";
import AssetDetailPage from "../pages/client/case/Asset/AssetDetailPage";
import AssetFunds from "../pages/client/case/Asset/AssetFunds";
import AssetPayments from "../pages/client/case/Asset/AssetPayments";
import AssetPaymentCommissions from "../pages/client/case/Asset/AssetPaymentCommissions";
import AssetWithdrawals from "../pages/client/case/Asset/AssetWithdrawals";
import AssetActions from "../pages/client/case/Asset/AssetActions";
import AssetValuations from "../pages/client/case/Asset/AssetValuations";
import LiabilityHomePage from "../pages/client/case/Liability/LiabilityHomePage";
import LiabilityDetailPage from "../pages/client/case/Liability/LiabilityDetailPage";
import LiabilityPayments from "../pages/client/case/Liability/LiabilityPayments";
import LiabilityPaymentCommission from "../pages/client/case/Liability/LiabilityPaymentCommissions";
import LiabilityActions from "../pages/client/case/Liability/LiabilityActions";
import AssetCommissionDistribution from "../pages/client/case/Asset/AssetCommissionDistribution";
import LiabilityCommissionDistribution from "../pages/client/case/Liability/LiabilityCommissionDistribution";
import PolicyHomePage from "../pages/client/case/Policy/PolicyHomePage";
import PolicyDetailPage from "../pages/client/case/Policy/PolicyDetailPage";
import PolicyFunds from "../pages/client/case/Policy/PolicyFunds";
import PolicyPayments from "../pages/client/case/Policy/PolicyPayments";
import PolicyPaymentCommissions from "../pages/client/case/Policy/PolicyPaymentCommissions";
import PolicyWithdrawals from "../pages/client/case/Policy/PolicyWithdrawals";
import PolicyActions from "../pages/client/case/Policy/PolicyActions";
import PolicyValuations from "../pages/client/case/Policy/PolicyValuations";
import PolicyCommissionDistribution from "../pages/client/case/Policy/PolicyCommissionDistribution";
import DynamicReport from "../pages/DynamicReport/Report";
import IncomeCategoryHomePage from "../pages/systemManager/masterSettings/IncomeCategories/IncomeCategoryHomePage";
import IncomeCategoryDetailPage from "../pages/systemManager/masterSettings/IncomeCategories/IncomeCategoryDetailPage";
import ExpenseCategoryHomePage from "../pages/systemManager/masterSettings/ExpenseCategories/ExpenseCategoryHomePage";
import ExpenseCategoryDetailPage from "../pages/systemManager/masterSettings/ExpenseCategories/ExpenseCategoryDetailPage";
import AttitudeToRiskCategoryDetailPage from "../pages/systemManager/masterSettings/AttitudeToRiskCategories/AttitudeToRiskCategoryDetailPage";
import AttitudeToRiskCategoryHomePage from "../pages/systemManager/masterSettings/AttitudeToRiskCategories/AttitudeToRiskCategoryHomePage";
import AttitudeToRiskRatingHomePage from "../pages/systemManager/masterSettings/AttitudeToRiskRatings/AttitudeToRiskRatingHomePage";
import AttitudeToRiskRatingDetailPage from "../pages/systemManager/masterSettings/AttitudeToRiskRatings/AttitudeToRiskRatingDetailPage";
import ObjectivesHomePage from "../pages/systemManager/masterSettings/Objectives/ObjectivesHomePage";
import ObjectivesDetailPage from "../pages/systemManager/masterSettings/Objectives/ObjectivesDetailPage";
import ClientActionsHomePage from "../pages/systemManager/masterSettings/ClientAction/ClientActionsHomePage";
import ClientActionsDetailPage from "../pages/systemManager/masterSettings/ClientAction/ClientActionsDetailPage";
import CaseActionsHomePage from "../pages/systemManager/masterSettings/CaseAction/CaseActionsHomePage";
import CaseActionsDetailPage from "../pages/systemManager/masterSettings/CaseAction/CaseActionsDetailPage";
import UserDefinedFieldsHomePage from "../pages/systemManager/masterSettings/UserDefinedForm/UserDefinedFieldsHomePage";
import UserDefinedFieldsDetailPage from "../pages/systemManager/masterSettings/UserDefinedForm/UserDefinedFieldsDetailPage";
import CommissionRulesHomePage from "../pages/systemManager/commission/CommissionRulesHomePage";
import CommissionRulesDetailPage from "../pages/systemManager/commission/CommissionRulesDetailPage";
import CommissionTypesHomePage from "../pages/systemManager/commission/CommissionTypesHomePage";
import CommissionTypesDetailPage from "../pages/systemManager/commission/CommissionTypesDetailPage";
import ManageUserHomePage from "../pages/systemManager/manageUser/ManageUserHomePage";
import ManageUserDetailPage from "../pages/systemManager/manageUser/ManageUserDetailPage";
import AssystPortal from "../pages/AssystPortal";
import VulnerabilityHomePage from "../pages/client/Vulnerability/VulnerabilityHomepage";
import VulnerabilityDetailPage from "../pages/client/Vulnerability/VulnerabilityDetailPage";
import PartnerVulnerabilityHomePage from "../pages/client/Vulnerability/PartnerVulnerabilityHomePage";
import PartnerVulnerabilityDetailPage from "../pages/client/Vulnerability/PartnerVulnerabilityDetailPage";
import ProviderDetailPage from "../pages/systemManager/Providers/ProviderDetailPage";
import ProviderHomePage from "../pages/systemManager/Providers/ProviderHomePage";
import RunLog from "../pages/systemManager/integrations/runlog/runLog";
import Distributionlist from "../pages/Commission/CommissionDistribution/Distributionlist";

export const PrivateRoutes = () => {
  const [mode, setMode] = useState("view");

  const loggedUser = useSelector((state: RootState) => state.authUser);
  const sideMenuGlobal = {
    actionList: [],
    clients: [],
    reports: [],
    utilities: [],
    systemManager: [
      { label: "Subscription" },
      { label: "Manage Users", link: "/system-manager/manage-user" },
      { label: "Commission", link: "/system-manager/Commission" },
    ],
  };

  if (
    checkUserPermission(
      loggedUser,
      UserPermissionsList.ALLOW_UPDATE_MASTER_DATA,
    )
  ) {
    const manageUsersIndex = sideMenuGlobal.systemManager.findIndex(
      (item) => item.label === "Manage Users",
    );
    sideMenuGlobal.systemManager.splice(manageUsersIndex + 1, 0, {
      label: "Master Settings",
      link: "/system-manager",
    });
  }

  const [tabs, setTabs] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  const [isMaster, setIsMaster] = useState(false);
  useEffect(() => {
    if (
      checkUserPermission(
        loggedUser,
        UserPermissionsList.ALLOW_UPDATE_MASTER_DATA,
      )
    ) {
      setIsMaster(true);
      setActiveMenu("Master Settings");
    } else {
      setActiveMenu("Manage Users");
      setIsMaster(false);
    }
  }, [loggedUser]);
  const sections = [
    "client_portal",
    "dependant",
    "income",
    "outgoings",
    "address-book",
    "fact-find-notes",
    "fees-charges",
    "employment",
    "attitude-to-risk",
    "identity",
    "objectives",
    "service-type",
    "user-defined",
  ];
  const partnerSections = [
    "employment",
    "attitude-to-risk",
    "identity",
    "objectives",
    "service-type",
  ];
  const contactsRoutes = [
    {
      path: "client-action",
      section: "client-action",
    },
    {
      path: "notes",
      section: "notes",
    },
    {
      path: "time-allocation",
      section: "time-allocation",
    },
  ];
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ClientLayout
            tabs={tabs}
            sideMenuGlobal={sideMenuGlobal}
            activeMenu={activeMenu}
          />
        }
      >
        <Route index element={<ClientList />} />
        <Route path="/clients" element={<ClientList />} />
        <Route path="/clients/add" element={<ClientAddForm />} />
        <Route path="clients/:clientId" element={<ClientDetailPage />}>
          <Route index element={<SectionHandler />} />
          <Route path=":section" element={<SectionHandler />} />
          <Route path=":section/:action" element={<SectionHandler />} />
          {/* <Route path="fees-charges" element={<FeesAndChargesHomePage />} />
          <Route
            path="fees-charges/:action"
            element={<FeesAndChargesDetailPage />}
          />
          <Route
            path="fees-charges/:selectedItemId"
            element={<FeesAndChargesDetailPage />}
          />
          <Route
            path="fees-charges/:selectedItemId/:action"
            element={<FeesAndChargesDetailPage />}
          /> */}
          <Route path="vulnerability" element={<VulnerabilityHomePage />} />
          <Route
            path="vulnerability/:action"
            element={<VulnerabilityDetailPage />}
          />
          <Route
            path="vulnerability/:selectedItemId"
            element={<VulnerabilityDetailPage />}
          />
          <Route
            path="vulnerability/:selectedItemId/:action"
            element={<VulnerabilityDetailPage />}
          />

          {sections.map((section) => (
            <React.Fragment key={section}>
              <Route
                path={section}
                element={<ClientSubMenuItem section={section} />}
              />
              <Route
                path={`${section}/:action`}
                element={<ClientSubMenuItem section={section} />}
              />
              <Route
                path={`${section}/:selectedItemId`}
                element={<ClientSubMenuItem section={section} />}
              />
              <Route
                path={`${section}/:selectedItemId/:action`}
                element={<ClientSubMenuItem section={section} />}
              />
            </React.Fragment>
          ))}
          {/* documents: redirect bare /documents to /documents/assyst-drive */}
          <Route path="documents" element={<Navigate to="assyst-drive" replace />} />
          <Route
            path="documents/*"
            element={<ClientSubMenuItem section={"documents"} />}
          />

          <Route
            path="contacts"
            element={<ClientSubMenuItem section={"client-action"} />}
          />
          <Route
            path="contacts/client-action"
            element={<ClientSubMenuItem section={"client-action"} />}
          />
          <Route
            path="contacts/client-action/:action"
            element={<ClientSubMenuItem section={"client-action"} />}
          />
          <Route
            path="contacts/client-action/:selectedItemId/:action"
            element={<ClientSubMenuItem section={"client-action"} />}
          />
          <Route
            path="contacts/notes"
            element={<ClientSubMenuItem section={"notes"} />}
          />
          <Route
            path="contacts/notes/:action"
            element={<ClientSubMenuItem section={"notes"} />}
          />
          <Route
            path="contacts/notes/:selectedItemId/:action"
            element={<ClientSubMenuItem section={"notes"} />}
          />
          <Route
            path="contacts/time-allocation"
            element={<ClientSubMenuItem section={"time-allocation"} />}
          />
          <Route
            path="contacts/time-allocation/:action"
            element={<ClientSubMenuItem section={"time-allocation"} />}
          />
          <Route
            path="contacts/time-allocation/:selectedItemId/:action"
            element={<ClientSubMenuItem section={"time-allocation"} />}
          />

          {/* {contactsRoutes.map(({ path, section }) => (
            <Route
              key={path}
              path={`contacts/${path}`}
              element={<ClientSubMenuItem section={section} />}
            >
              <Route
                path=":action"
                element={<ClientSubMenuItem section={section} />}
              />
              <Route
                path=":selectedItemId/:action"
                element={<ClientSubMenuItem section={section} />}
              />
            </Route>
          ))} */}
          <Route path="partner" element={<PartnerSectionHandler />} />
          <Route path="partner/:section" element={<PartnerSectionHandler />} />
          <Route
            path="partner/:section/:action"
            element={<PartnerSectionHandler />}
          />
          <Route
            path="partner/vulnerability"
            element={<PartnerVulnerabilityHomePage />}
          />
          <Route
            path="partner/vulnerability/:action"
            element={<PartnerVulnerabilityDetailPage />}
          />
          <Route
            path="partner/vulnerability/:selectedItemId"
            element={<PartnerVulnerabilityDetailPage />}
          />
          <Route
            path="partner/vulnerability/:selectedItemId/:action"
            element={<PartnerVulnerabilityDetailPage />}
          />
          {partnerSections.map((section) => (
            <React.Fragment key={`partner/${section}`}>
              <Route
                path={`partner/${section}`}
                element={<PartnerSubMenuItem section={section} />}
              />
              <Route
                path={`partner/${section}/:action`}
                element={<PartnerSubMenuItem section={section} />}
              />
              <Route
                path={`partner/${section}/:selectedItemId`}
                element={<PartnerSubMenuItem section={section} />}
              />
              <Route
                path={`partner/${section}/:selectedItemId/:action`}
                element={<PartnerSubMenuItem section={section} />}
              />
            </React.Fragment>
          ))}
          {/* <Route path="assets" element={<CaseHomePage section="assets" />} /> */}
          <Route path="assets" element={<AssetHomePage />} />
          <Route
            path="assets/:action"
            element={<AssetDetailPage tab="asset" />}
          />
          <Route
            path="assets/:caseId/asset"
            element={<AssetDetailPage tab="asset" />}
          />
          <Route
            path="assets/:caseId/asset/:action"
            element={<AssetDetailPage tab="asset" />}
          />
          <Route
            path="assets/:caseId/review"
            element={<AssetDetailPage tab="review" />}
          />
          <Route
            path="assets/:caseId/review/:action"
            element={<AssetDetailPage tab="review" />}
          />
          <Route
            path="assets/:caseId/funds"
            element={<AssetFunds tab="fund" />}
          />
          <Route
            path="assets/:caseId/fund/:action"
            element={<AssetFunds tab="fund" />}
          />
          <Route
            path="assets/:caseId/funds/:action"
            element={<AssetFunds tab="fund" />}
          />
          <Route
            path="assets/:caseId/funds/:subItemId/fund"
            element={<AssetFunds tab="fund" />}
          />
          <Route
            path="assets/:caseId/funds/:subItemId/fund/:action"
            element={<AssetFunds tab="fund" />}
          />

          <Route
            path="assets/:caseId/payments"
            element={<AssetPayments tab="payment" />}
          />
          <Route
            path="assets/:caseId/payment/:action"
            element={<AssetPayments tab="payment" />}
          />
          <Route
            path="assets/:caseId/payments/:action"
            element={<AssetPayments tab="payment" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/payment"
            element={<AssetPayments tab="payment" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/payment/:action"
            element={<AssetPayments tab="payment" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/compliance"
            element={<AssetPayments tab="compliance" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/compliance/:action"
            element={<AssetPayments tab="compliance" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission"
            element={<AssetPaymentCommissions tab="commission" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:action"
            element={<AssetPaymentCommissions tab="commission" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/commission"
            element={<AssetPaymentCommissions tab="commission" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/commission/:action"
            element={<AssetPaymentCommissions tab="commission" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/distribution"
            element={<AssetCommissionDistribution tab="distribution" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:action"
            element={<AssetCommissionDistribution tab="distribution" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution"
            element={<AssetCommissionDistribution tab="distribution" />}
          />
          <Route
            path="assets/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution/:action"
            element={<AssetCommissionDistribution tab="distribution" />}
          />
          <Route
            path="assets/:caseId/withdrawals"
            element={<AssetWithdrawals tab="withdrawal" />}
          />
          <Route
            path="assets/:caseId/withdrawal/:action"
            element={<AssetWithdrawals tab="withdrawal" />}
          />
          <Route
            path="assets/:caseId/withdrawals/:action"
            element={<AssetWithdrawals tab="withdrawal" />}
          />
          <Route
            path="assets/:caseId/withdrawals/:subItemId/withdrawal"
            element={<AssetWithdrawals tab="withdrawal" />}
          />
          <Route
            path="assets/:caseId/withdrawals/:subItemId/withdrawal/:action"
            element={<AssetWithdrawals tab="withdrawal" />}
          />
          <Route
            path="assets/:caseId/actions"
            element={<AssetActions tab="action" />}
          />
          <Route
            path="assets/:caseId/action/:action"
            element={<AssetActions tab="action" />}
          />
          <Route
            path="assets/:caseId/actions/:action"
            element={<AssetActions tab="action" />}
          />
          <Route
            path="assets/:caseId/actions/:subItemId/action"
            element={<AssetActions tab="action" />}
          />
          <Route
            path="assets/:caseId/actions/:subItemId/action/:action"
            element={<AssetActions tab="action" />}
          />
          <Route
            path="assets/:caseId/valuations"
            element={<AssetValuations tab="valuation" />}
          />
          <Route
            path="assets/:caseId/valuation/:action"
            element={<AssetValuations tab="valuation" />}
          />
          <Route
            path="assets/:caseId/valuations/:action"
            element={<AssetValuations tab="valuation" />}
          />
          <Route
            path="assets/:caseId/valuations/:subItemId/valuation"
            element={<AssetValuations tab="valuation" />}
          />
          <Route
            path="assets/:caseId/valuations/:subItemId/valuation/:action"
            element={<AssetValuations tab="valuation" />}
          />
          <Route path="liabilities" element={<LiabilityHomePage />} />

          <Route
            path="liabilities/:action"
            element={<LiabilityDetailPage tab="liability" />}
          />
          <Route
            path="liabilities/:caseId/liability"
            element={<LiabilityDetailPage tab="liability" />}
          />
          <Route
            path="liabilities/:caseId/liability/:action"
            element={<LiabilityDetailPage tab="liability" />}
          />
          <Route
            path="liabilities/:caseId/review"
            element={<LiabilityDetailPage tab="review" />}
          />
          <Route
            path="liabilities/:caseId/review/:action"
            element={<LiabilityDetailPage tab="review" />}
          />

          <Route
            path="liabilities/:caseId/payments"
            element={<LiabilityPayments tab="payment" />}
          />
          <Route
            path="liabilities/:caseId/payment/:action"
            element={<LiabilityPayments tab="payment" />}
          />
          <Route
            path="liabilities/:caseId/payments/:action"
            element={<LiabilityPayments tab="payment" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/payment/:action"
            element={<LiabilityPayments tab="payment" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/compliance/:action"
            element={<LiabilityPayments tab="compliance" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/payment"
            element={<LiabilityPayments tab="payment" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/compliance"
            element={<LiabilityPayments tab="compliance" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission"
            element={<LiabilityPaymentCommission tab="commission" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:action"
            element={<LiabilityPaymentCommission tab="commission" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/commission"
            element={<LiabilityPaymentCommission tab="commission" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/commission/:action"
            element={<LiabilityPaymentCommission tab="commission" />}
          />

          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/distribution"
            element={<LiabilityCommissionDistribution tab="distribution" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:action"
            element={<LiabilityCommissionDistribution tab="distribution" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution"
            element={<LiabilityCommissionDistribution tab="distribution" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution"
            element={<LiabilityCommissionDistribution tab="distribution" />}
          />
          <Route
            path="liabilities/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution/:action"
            element={<LiabilityCommissionDistribution tab="distribution" />}
          />

          <Route
            path="liabilities/:caseId/actions"
            element={<LiabilityActions tab="action" />}
          />
          <Route
            path="liabilities/:caseId/action/:action"
            element={<LiabilityActions tab="action" />}
          />
          <Route
            path="liabilities/:caseId/actions/:action"
            element={<LiabilityActions tab="action" />}
          />
          <Route
            path="liabilities/:caseId/actions/:subItemId/action"
            element={<LiabilityActions tab="action" />}
          />
          <Route
            path="liabilities/:caseId/actions/:subItemId/action/:action"
            element={<LiabilityActions tab="action" />}
          />

          <Route path="policies" element={<PolicyHomePage />} />

          <Route
            path="policies/:action"
            element={<PolicyDetailPage tab="policy" />}
          />
          <Route
            path="policies/:caseId/policy"
            element={<PolicyDetailPage tab="policy" />}
          />
          <Route
            path="policies/:caseId/policy/:action"
            element={<PolicyDetailPage tab="policy" />}
          />
          <Route
            path="policies/:caseId/review"
            element={<PolicyDetailPage tab="review" />}
          />
          <Route
            path="policies/:caseId/review/:action"
            element={<PolicyDetailPage tab="review" />}
          />
          <Route
            path="policies/:caseId/funds"
            element={<PolicyFunds tab="fund" />}
          />
          <Route
            path="policies/:caseId/fund/:action"
            element={<PolicyFunds tab="fund" />}
          />
          <Route
            path="policies/:caseId/funds/:action"
            element={<PolicyFunds tab="fund" />}
          />
          <Route
            path="policies/:caseId/funds/:subItemId/fund"
            element={<PolicyFunds tab="fund" />}
          />
          <Route
            path="policies/:caseId/funds/:subItemId/fund/:action"
            element={<PolicyFunds tab="fund" />}
          />

          <Route
            path="policies/:caseId/payments"
            element={<PolicyPayments tab="payment" />}
          />
          <Route
            path="policies/:caseId/payment/:action"
            element={<PolicyPayments tab="payment" />}
          />
          <Route
            path="policies/:caseId/payments/:action"
            element={<PolicyPayments tab="payment" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/payment"
            element={<PolicyPayments tab="payment" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/compliance"
            element={<PolicyPayments tab="compliance" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/payment/:action"
            element={<PolicyPayments tab="payment" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/compliance/:action"
            element={<PolicyPayments tab="compliance" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission"
            element={<PolicyPaymentCommissions tab="commission" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:action"
            element={<PolicyPaymentCommissions tab="commission" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/commission"
            element={<PolicyPaymentCommissions tab="commission" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/commission/:action"
            element={<PolicyPaymentCommissions tab="commission" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/distribution"
            element={<PolicyCommissionDistribution tab="distribution" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:action"
            element={<PolicyCommissionDistribution tab="distribution" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution"
            element={<PolicyCommissionDistribution tab="distribution" />}
          />
          <Route
            path="policies/:caseId/payments/:subItemId/commission/:subSubItemId/distribution/:distributionId/distribution/:action"
            element={<PolicyCommissionDistribution tab="distribution" />}
          />
          <Route
            path="policies/:caseId/withdrawals"
            element={<PolicyWithdrawals tab="withdrawal" />}
          />
          <Route
            path="policies/:caseId/withdrawal/:action"
            element={<PolicyWithdrawals tab="withdrawal" />}
          />
          <Route
            path="policies/:caseId/withdrawals/:action"
            element={<PolicyWithdrawals tab="withdrawal" />}
          />
          <Route
            path="policies/:caseId/withdrawals/:subItemId/withdrawal"
            element={<PolicyWithdrawals tab="withdrawal" />}
          />
          <Route
            path="policies/:caseId/withdrawals/:subItemId/withdrawal/:action"
            element={<PolicyWithdrawals tab="withdrawal" />}
          />
          <Route
            path="policies/:caseId/actions"
            element={<PolicyActions tab="action" />}
          />
          <Route
            path="policies/:caseId/action/:action"
            element={<PolicyActions tab="action" />}
          />
          <Route
            path="policies/:caseId/actions/:action"
            element={<PolicyActions tab="action" />}
          />
          <Route
            path="policies/:caseId/actions/:subItemId/action"
            element={<PolicyActions tab="action" />}
          />
          <Route
            path="policies/:caseId/actions/:subItemId/action/:action"
            element={<PolicyActions tab="action" />}
          />
          <Route
            path="policies/:caseId/valuations"
            element={<PolicyValuations tab="valuation" />}
          />
          <Route
            path="policies/:caseId/valuation/:action"
            element={<PolicyValuations tab="valuation" />}
          />
          <Route
            path="policies/:caseId/valuations/:action"
            element={<PolicyValuations tab="valuation" />}
          />
          <Route
            path="policies/:caseId/valuations/:subItemId/valuation"
            element={<PolicyValuations tab="valuation" />}
          />
          <Route
            path="policies/:caseId/valuations/:subItemId/valuation/:action"
            element={<PolicyValuations tab="valuation" />}
          />
        </Route>
        <Route path="/action-list" element={<ActionList />} />
        <Route path="/assyst_portal" element={<AssystPortal />} />
        {/* <Route path="/report" element={<Report setTabs={setTabs} />} /> */}
        {/* <Route path="/reportdemo" element={<ReportDemo />} /> */}
        <Route path="/report" element={<DynamicReport />} />

        <Route path="/commission" element={<CommissionLayout />}>
          <Route index element={<ReceiptList />} />

          <Route path="receipting" element={<ReceiptList />} />
          <Route path="distribution" element={<Distributionlist />} />

          {/* <Route
            path="/commission/other-fees-charges"
            element={<FeeschargesList />}
          /> */}
        </Route>
        <Route
          path="/system-manager"
          element={<SystemManagerLayout setTabs={setTabs} />}
        >
          <Route path="" element={<CompanyDetails />} />
          <Route path="master-settings" element={<MasterSttingsPage />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="company-details" element={<CompanyDetails />} />
          <Route path="contract-enquiry" element={<ContractEnquiry />} />
          <Route path="providers" element={<ProviderHomePage />} />
          <Route path="providers/:action" element={<ProviderDetailPage />} />
          <Route path="providers/:itemId" element={<ProviderDetailPage />} />
          <Route
            path="providers/:itemId/:action"
            element={<ProviderDetailPage />}
          />

          <Route path="/system-manager/templates" element={<Templates />} />
          <Route path="templates/:section" element={<Templates />} />
          <Route path="template/:section" element={<EmailTemplates />} />
          <Route
            path="/system-manager/customisations"
            element={<MasterSttingsPage />}
          />
          <Route
            path="customisations/income-category"
            element={<IncomeCategoryHomePage />}
          />
          <Route
            path="customisations/income-category/:action"
            element={<IncomeCategoryDetailPage />}
          />
          <Route
            path="customisations/income-category/:itemId"
            element={<IncomeCategoryDetailPage />}
          />
          <Route
            path="customisations/income-category/:itemId/:action"
            element={<IncomeCategoryDetailPage />}
          />
          <Route
            path="customisations/expense-category"
            element={<ExpenseCategoryHomePage />}
          />
          <Route
            path="customisations/expense-category/:action"
            element={<ExpenseCategoryDetailPage />}
          />
          <Route
            path="customisations/expense-category/:itemId"
            element={<ExpenseCategoryDetailPage />}
          />
          <Route
            path="customisations/expense-category/:itemId/:action"
            element={<ExpenseCategoryDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-categories"
            element={<AttitudeToRiskCategoryHomePage />}
          />
          <Route
            path="customisations/attitude-risk-categories/:action"
            element={<AttitudeToRiskCategoryDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-categories/:itemId"
            element={<AttitudeToRiskCategoryDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-categories/:itemId/:action"
            element={<AttitudeToRiskCategoryDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-ratings"
            element={<AttitudeToRiskRatingHomePage />}
          />
          <Route
            path="customisations/attitude-risk-ratings/:action"
            element={<AttitudeToRiskRatingDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-ratings/:itemId"
            element={<AttitudeToRiskRatingDetailPage />}
          />
          <Route
            path="customisations/attitude-risk-ratings/:itemId/:action"
            element={<AttitudeToRiskRatingDetailPage />}
          />
          <Route
            path="customisations/objectives"
            element={<ObjectivesHomePage />}
          />
          <Route
            path="customisations/objectives/:action"
            element={<ObjectivesDetailPage />}
          />
          <Route
            path="customisations/objectives/:itemId"
            element={<ObjectivesDetailPage />}
          />
          <Route
            path="customisations/objectives/:itemId/:action"
            element={<ObjectivesDetailPage />}
          />
          <Route
            path="customisations/client-action"
            element={<ClientActionsHomePage />}
          />
          <Route
            path="customisations/client-action/:action"
            element={<ClientActionsDetailPage />}
          />
          <Route
            path="customisations/client-action/:itemId"
            element={<ClientActionsDetailPage />}
          />
          <Route
            path="customisations/client-action/:itemId/:action"
            element={<ClientActionsDetailPage />}
          />
          <Route
            path="customisations/case-action"
            element={<CaseActionsHomePage />}
          />
          <Route
            path="customisations/case-action/:action"
            element={<CaseActionsDetailPage />}
          />
          <Route
            path="customisations/case-action/:itemId"
            element={<CaseActionsDetailPage />}
          />
          <Route
            path="customisations/case-action/:itemId/:action"
            element={<CaseActionsDetailPage />}
          />
          <Route
            path="customisations/user-defined"
            element={<UserDefinedFieldsHomePage />}
          />
          <Route
            path="customisations/user-defined/:action"
            element={<UserDefinedFieldsDetailPage />}
          />
          <Route
            path="customisations/user-defined/:itemId"
            element={<UserDefinedFieldsDetailPage />}
          />
          <Route
            path="customisations/user-defined/:itemId/:action"
            element={<UserDefinedFieldsDetailPage />}
          />
          <Route
            path="customisations/:section"
            element={<MasterSttingsPage />}
          />
          {/* <Route
            path="manage-user"
            element={<ManageUser setActiveMenu={setActiveMenu} />}
          /> */}

          <Route path="manage-user" element={<ManageUserHomePage />} />
          <Route
            path="manage-user/:action"
            element={<ManageUserDetailPage />}
          />
          <Route
            path="manage-user/:userId"
            element={<ManageUserDetailPage />}
          />
          <Route
            path="manage-user/:userId/:action"
            element={<ManageUserDetailPage />}
          />
          <Route path="integrations/run_logs" element={<RunLog />} />
          <Route path="commission" element={<Commission />} />
          <Route
            path="commission/commission-rule"
            element={<CommissionRulesHomePage />}
          />
          <Route
            path="commission/commission-rule/:action"
            element={<CommissionRulesDetailPage />}
          />
          <Route
            path="commission/commission-rule/:itemId"
            element={<CommissionRulesDetailPage />}
          />
          <Route
            path="commission/commission-rule/:itemId/:action"
            element={<CommissionRulesDetailPage />}
          />
          <Route
            path="commission/commission-type"
            element={<CommissionTypesHomePage />}
          />
          <Route
            path="commission/commission-type/:action"
            element={<CommissionTypesDetailPage />}
          />
          <Route
            path="commission/commission-type/:itemId"
            element={<CommissionTypesDetailPage />}
          />
          <Route
            path="commission/commission-type/:itemId/:action"
            element={<CommissionTypesDetailPage />}
          />
          <Route path="commission/:section" element={<Commission />} />
        </Route>

        <Route
          path="/profile"
          element={
            <ProfileSettings
              setActiveMenu={setActiveMenu}
              mode={mode}
              setMode={setMode}
            />
          }
        >
          <Route
            path=":section"
            element={<ProfileRouting mode={mode} setMode={setMode} />}
          />
          <Route index element={<Navigate to="/profile/account" replace />} />
        </Route>
        <Route path="/utilities" element={<UtilitiesLayout />}>
          <Route index element={<TemplateDropdown />} />
          {/* <Route path="report" element={<ReportDemo />} /> */}
          <Route path="email" element={<TemplateDropdown />} />
          <Route path="letter" element={<LetterGeneration />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
